module.exports = __webpack_public_path__ + "img/00041.59bab9b6.webp";